export default __webpack_public_path__ + "static/media/service4.b0d1eff6.jpeg";